import React, { useEffect, useRef, useState } from "react";
import Navbar from "./Navbar";
import "../../App.css";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Footer from "./Footer";
import Sidebar from "./Sidebar";

const Layout = () => {
  const sidebarRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsSidebarOpen(false);
    }
  };

  // Reset scroll position on route change
  useEffect(() => {
    window.scrollTo(0, 0);
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  // Check if mobile view
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    if (isSidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen]);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="w-full min-h-screen flex bg-[#F9F9F9]">
        {/* Sidebar - Fixed positioning for both mobile and desktop */}
        <div 
          ref={sidebarRef}
          className={`fixed inset-y-0 left-0 z-50 transform ${
            isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
          } lg:translate-x-0 transition-transform duration-300 ease-in-out`}
        >
          <Sidebar 
            isOpen={isSidebarOpen} 
            onClose={() => setIsSidebarOpen(false)} 
          />
        </div>

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col min-w-0 lg:ml-64"> {/* Added lg:ml-64 to account for sidebar width */}
          {/* Navbar */}
          {/* <div className="w-full sticky top-0 z-40 flex-shrink-0">
            <Navbar 
              onToggleSidebar={toggleSidebar}
              isSidebarOpen={isSidebarOpen}
            />
          </div> */}
          
          {/* Page Content */}
          <div className="flex-1 overflow-auto">
            <div className="min-h-full p-4 lg:p-6">
              <Outlet />
            </div>
          </div>
          
          {/* Footer */}
          <div className="flex-shrink-0">
            <Footer />
          </div>
        </div>

        {/* Overlay for mobile sidebar */}
        {isSidebarOpen && isMobile && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={() => setIsSidebarOpen(false)}
          ></div>
        )}
      </div>
    </>
  );
};

export default Layout;